import axios from "axios";
import { SERVER_URL } from "Constants";
import { getStripeSessionDetail } from "Hooks/Api/apiStripe";
import useAsync from "Hooks/useAsync";
import { OrganisationEntity, PaymentMethodEntity } from "Models/Entities";
import { store } from "Models/Store";
import { useEffect } from "react";
import { useLocation } from "react-router";
import alertToast from "Util/ToastifyUtils";
import Modal from "Views/Components/Modal/Modal";
import InlineSpinner from "Views/Components/Spinner/InlineSpinner";
import { SetupPaymentSection } from "Views/Components/StripePayment/SetupPaymentSection";

const fetchAvailablePaymentMethods = async (organisationId: string) => {
	try {
		const response = await axios.get<PaymentMethodEntity[]>(
			`${SERVER_URL}/api/entity/organisationEntity/${organisationId}/payment-methods`
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return [];
	}
}

type Props = {
	organisation: OrganisationEntity,
	businessEntityId: string | undefined,
	redirectUrl: string,
	onClose: () => void
}

export const PaymentMethodModal: React.FunctionComponent<Props> = ({
	organisation,
	businessEntityId,
	redirectUrl,
	onClose
}) => {
	const location = useLocation();
	const sessionId = new URLSearchParams(location.search).get("session_id");

	const availablePaymentMethods = useAsync(async () => {
		const paymentMethods = await fetchAvailablePaymentMethods(organisation.id);
		return paymentMethods;
	}, [organisation.id]);

	useEffect(() => {
		if (!!sessionId) {
			const checkSessionStatus = async () => {
				const response = await getStripeSessionDetail(sessionId);
				
				if (response && response.hasCompleted) {
					alertToast("Payment method Successfully added!", "success");
				} else {
					alertToast("Failed to add payment method. Please try again", "error");
				}
			}

			checkSessionStatus()
				.catch(console.error)
				.finally(() => {
					store.routerHistory.push(redirectUrl);
				});
		}
	}, [sessionId, redirectUrl]);
	return (
		<Modal
			isOpen
			label="Payment method"
			className="access-modal"
		>
			<div className="organisation-payment-setup">
				{availablePaymentMethods.type === "loading" && (
					<InlineSpinner />
				)}
				{availablePaymentMethods.type === "error" && (
					<div>Failed to load payment methods. Please try again</div>
				)}
				{availablePaymentMethods.type === "data" && (
					<>
						<h3>{availablePaymentMethods.data.length === 0 ? "Add" : "Update"} payment method</h3>
						<SetupPaymentSection 
							organisation={organisation} 
							businessEntityId={businessEntityId}
							redirectUrl={redirectUrl} 
							onCancel={onClose}
						/>
					</>
				)}
			</div>
		</Modal>
	);
}